import React from 'react'
import { useTranslation } from 'next-i18next'
import userApi from 'src/api/userApi'
import useGetWithContext from 'src/hooks/useGetWithContext'
import { formatNumberDdMMyyyy } from 'src/libs/date'
import { gradeToTeacherGrade } from 'src/libs/util'
import configApi from 'src/api/configApi'
import { keyBy } from 'lodash'
import { GRADE_TEACHER_CONVERT } from 'src/libs/constant'
import { IconStar } from 'src/images/iconSvg'

export const TeacherCharacteristic = ({ teacherId }) => {
  const { data } = useGetWithContext(`GET_USER_BY_ID_${teacherId}`, userApi.detail, teacherId, { isDisabled: !teacherId })
  if (!data) return null
  return <span>{data?.userInfoData?.find(item => item.field?.shortName === 'note')?.data || null}</span>
}

export const TeacherCertificate = ({ teacherId }) => {
  const { t } = useTranslation()
  const { data: teacher } = useGetWithContext(
    `GET_TEACHER_DETAIL_BY_ID${teacherId}`,
    userApi.detailTeacher,
    teacherId,
    { isDisabled: !teacherId }
  )
  if (!teacher) return null
  const { teacherInfo } = teacher
  const { certificate, certificateNote } = teacherInfo
  return (
    <>
      {certificate && (
        <>
          <span className='d-block'>
            {JSON.parse(certificate)?.map((item) => t(`constant.certificate.${item}`)).join(',')}
          </span>
          <span className='d-block'>{certificateNote}</span>
        </>
      )}
    </>
  )
}

export const TeacherLevel = ({ teacherLevelId, density, densityRate, proportion }) => {
  const { data: salaryData } = useGetWithContext('GET_LIST_SALARY', configApi.getListSalaryGroup)
  const salaryDataById = salaryData ? keyBy(salaryData, 'id') : {}
  return (
    <div>
      <span>Cấp bậc: {salaryDataById[teacherLevelId]?.name}</span>
      <span
        className='ml-1'
      >
        {(density !== undefined && density !== null) ? (density === true ? '(Dưới tỷ trọng)' : '(Vượt tỷ trọng)') : null}
      </span>
      {/*{*/}
      {/*  (densityRate || proportion) && (*/}
      {/*    <span className='ml-1'>{`(${densityRate}/${proportion})`}</span>*/}
      {/*  )*/}
      {/*}*/}
    </div>
  )
}
export const TeacherGrade = ({ grades, gradePriorities }) => {
  const { t } = useTranslation()
  const teacherGrade = gradeToTeacherGrade(grades)
  return (
    <>
      <span>{t('common.label.teacher_grade')}: &nbsp;</span>
      <span>
        {teacherGrade?.map((grade, idx) => {
          const convertedGrade = GRADE_TEACHER_CONVERT[grade]
          const isPriority = gradePriorities?.includes(convertedGrade)
          return (
            <span key={idx}>
                <span>{t(`constant.teacher_grade.${grade}`)}</span>
              {isPriority && <IconStar />}
              {idx !== teacherGrade.length - 1 && <span>, </span>}
              </span>
          )
        })}
      </span>
    </>
  )
}
export const TeacherHireDate = ({ hireDate }) => {
  const { t } = useTranslation()
  return (
    <span className='d-block'>
      {t('common.label.date_onboard')}: {formatNumberDdMMyyyy(hireDate)}
    </span>
  )
}
